import { Box, Flex, Stack } from '@chakra-ui/react';
import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';
import SidebarCard from 'components/sidebar/components/SidebarCard';
import React from 'react';

function SidebarContent(props) {
  const { routes, collapsed } = props;

  return (
    <Flex
      direction="column"
      minHeight="100%"
      pt="25px"
      px={collapsed ? '6px' : '16px'} // 🔥 dynamic padding
      borderRadius="30px"
      alignItems={collapsed ? 'center' : 'stretch'} // center icons when collapsed
    >
      {/* BRAND */}
      <Brand collapsed={collapsed} />

      {/* LINKS */}
      <Stack direction="column" mb="auto" mt="8px" width="100%">
        <Box
          ps={collapsed ? '0px' : '20px'} // remove left spacing
          pe={{ md: collapsed ? '0px' : '16px', '2xl': '1px' }}
          width="100%"
        >
          <Links routes={routes} collapsed={collapsed} />
        </Box>
      </Stack>
    </Flex>
  );
}

export default SidebarContent;
